// extracted by mini-css-extract-plugin
export default {"actionDiv":"divs-module___actionDiv___df906fff","flex":"divs-module___flex___d122362b","row":"divs-module___row___bdb8baf6","column":"divs-module___column___faee6ad2"};